/**
 * Whether Enter should add a line instead of sending: only on phones, whose on-screen keyboard has no other way to
 * add one (the send button sends). Tablets and computers send on Enter (Shift+Enter adds a line). The visual viewport
 * is not a usable test: an iPad's hardware keyboard and its floating shortcut bar shrink it like an on-screen keyboard,
 * so Enter added a line there and a message the user thought was sent was lost when the page closed.
 */
export function softKeyboardOpen(): boolean {
  const touch = typeof matchMedia === "function" && matchMedia("(pointer: coarse)").matches;
  return touch && Math.min(screen.width, screen.height) < 600;
}
